



























import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { UserService } from '@/api'

@Component({})
export default class PasswordForgot extends Vue {
  public sent = false
  public email = ''

  public register (): void {
    UserService.sendUserPassword({ requestBody: { email: this.email } }).finally(() => {
      this.sent = true
    })
  }
}
